import casinoServices from "../../services/CasinoService";
import memberService from "../../services/MemberService";
import _ from 'lodash';
import LiveCasinoService from "../../services/LiveCasinoService";

export default class LiveCasinoAction {

  /**
   * Call API to get game dispatcher Url
   */
  static async getGameDispatcherUrl(data) {
    return await memberService.getGameDispatcherUrlAPI(data).then(res => {
      return !_.isEmpty(res) ? res.data : {};
    }).catch(error => {
      console.log("Error getGameDispatcherUrl");
      throw error;
    });
  }

  /**
   * Call API to get casino login status
   */
  static async getCasinoLoginStatus() {
    return await memberService.getCasinoLoginStatusAPI().then(res => {
      return !_.isEmpty(res) ? res.data : {};
    }).catch(error => {
      console.log("Error getCasinoLoginStatus");
      throw error;
    });
  }


  /**
   * Call API to get CR855 Game Path
   */
  static async getCR855GamePath() {
    return await memberService.getCR855GamePathAPI().then(res => {
      return !_.isEmpty(res) ? res.data : {};
    }).catch(error => {
      console.log("Error getCR855GamePath");
      throw error;
    });
  }

  /**
   * Call API to get Live Casino AG games
   */
  static async getLiveCasinoGames(casinoFilter) {
    return await LiveCasinoService.getLiveCasinoGamesAPI(casinoFilter).then(res => {
      return !_.isEmpty(res) ? res.data : [];
    }).catch(error => {
      console.log("Error getLiveCasinoAGGames");
      throw error;
    });
  }
  
}


// WEBPACK FOOTER //
// ./src/app/components/LiveCasinoComponent/LiveCasinoAction.js